/* jshint esnext: true */
import { $document, APP_NAME, $body } from '../utils/environment';
import AbstractModule from './AbstractModule';
// import Scrollbar from 'smooth-scrollbar';
import LocomotiveScroll from './ScrollManager';

const MODULE_NAME = 'Timeline';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    // CLICK: `click.${EVENT_NAMESPACE}`,
    TRIGGERDATE: `triggerDate.Timeline`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        // Declaration of properties
    }

    init() {

        this.$valueItem = $('.js-value-item', this.$el);
        $document.on(EVENT.TRIGGERDATE,(e) => this.changeDate(e));

    }

    changeDate(e) {
        let value = e.options.value.toString();
        if (e.way === 'enter') {
            for (var i = 0; i < value.length; i++) {
                TweenMax.to(this.$valueItem.eq(i).find('.js-inner'),1,{
                    y: - ((parseInt(value[i]) + 1)*10) + '%',
                    delay: 0.3 + (i * 0.1)
                });
            }
        }

    }


    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }

}
